import { ThirtyFps, Try } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { getSignatureListByUser } from "Services/docForm.service";

export const useSignatureForms = () => {
    const [signatureImage, setSignatureImage] = useState(null);

    useEffect(() => {
        getSignatureList();
    }, []);

    const getSignatureList = async () => {
        try {
        const res = await getSignatureListByUser();
        console.log("getSignatureList res", res);
        if (res.status === 404) {
            setSignatureImage(null);
            return;
        }
        console.log("getSignatureList res", res);
        if(res.data.signatureUrl) {
            setSignatureImage(res.data.signatureUrl);
        }
        } catch (error) {
            console.error("Error fetching signature list:", error);
            
        }
    };

    return {
        signatureImage,
        getSignatureList,
    };
};